class MainMenuMobile {
    constructor() {
        const headerMain = document.querySelector('.header-main');
        const menuMobile = document.querySelector('.menu-header-mobile');
        const searchForm = document.querySelector('#searchform');
        const hamburgerMenu = document.querySelector('.header-main .hamburger-menu');
        const searchClose = document.querySelector('#searchform .close');

        hamburgerMenu.addEventListener('click', (e) => {
            if (menuMobile.classList.contains('opened')) {
                menuMobile.classList.remove('opened');
                hamburgerMenu.classList.remove('close');
            } else {
                menuMobile.classList.add('opened');
                hamburgerMenu.classList.add('close');
            }

            headerMain.classList.toggle('active');
        });

        searchClose.addEventListener('click', (e) => {
            e.preventDefault();
            searchForm.classList.remove('active');
            hamburgerMenu.classList.remove('close');
        });

        document.querySelector('header button.search').addEventListener('click', (e) => {
            searchForm.classList.add('active');
            menuMobile.classList.remove('opened');
            hamburgerMenu.classList.remove('close');
            e.stopPropagation();
        });

        document.addEventListener('click', () => {
            searchForm.classList.remove('active');
        });

        searchForm.addEventListener('click', (e) => {
            e.stopPropagation();
        });

    }
}

export default MainMenuMobile;